const baseHttp = "https://"
const routes = [
  {
    api: "CLOUDSG",
    environment: `HOMOLOGATION`,
    url: `${baseHttp}new-app.cloudsg.com.br/#!/`,
  },
  {
    api: "CLOUDSG",
    environment: `PRODUCTION`,
    url: `${baseHttp}app.cloudsg.com.br/#!/`,
  },
  {
    api: "CLOUDSG",
    environment: `DEVELOPMENT`,
    url: `http://localhost:1111/#!/`,
  },
  {
    api: "CLOUDSGRN",
    environment: `PRODUCTION`,
    url: `${baseHttp}apprn.cloudsg.com.br/#!/`,
  },
  {
    api: "SGMODA",
    environment: `PRODUCTION`,
    url: `${baseHttp}app.sgmoda.com.br/#!/`,
  },
  {
    api: "MOBIAGE",
    environment: `PRODUCTION`,
    url: `${baseHttp}app.mobiage.com.br/#!/`,
  },
  {
    api: "MOBIAGE",
    environment: `PRODUCTION`,
    url: `${baseHttp}app.mobiage.com.br/#!/`,
  },
  {
    api: "CLOUDSGMERC",
    environment: `PRODUCTION`,
    url: `${baseHttp}appmerc.cloudsg.com.br/#!/`,
  },
  {
    api: "CLOUDSGAA",
    environment: `PRODUCTION`,
    url: `${baseHttp}appaa.cloudsg.com.br/#!/`,
  },
  {
    api: "CLOUDSGVALIDACAO",
    environment: `PRODUCTION`,
    url: `${baseHttp}validacao-app.cloudsg.com.br/#!/`,
  },
]


export const appRoutesUtils = {
  getRoute : (params)=>{
    return routes.filter((route)=>{
      return route.api == params.api.toUpperCase() && route.environment == params.env.toUpperCase()
    })[0].url
  }
}